import * as React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const contactMethods = [{
  title: "Call/Text Us",
  value: "(626) 268-5990",
  icon: Phone
}, {
  title: "Visit Our Clinic",
  value: "4202 Peck Rd\nEl Monte, CA 91732",
  icon: MapPin
}, {
  title: "Email Us",
  value: "smartchoicedentures@gmail.com",
  icon: Mail
}];
export default function ReachOurTeam() {
  return <section data-section-id="128269" id="get-started-on-your-new-smile" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col max-w-xl">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-primary mb-6 leading-tight tracking-tighter">
              Get Started on Your New Smile
            </h1>
            <p className="text-xl md:text-2xl text-foreground/80 leading-relaxed font-sans">
              Experience affordable, efficient, and high-quality dental care at Smart Choice Dentures & Implants. Our El Monte specialists are ready to help you rediscover your confidence.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4 md:gap-6">
            {contactMethods.map((method, i) => <Card key={i} data-index={i} className="py-0 border-border/60 shadow-md hover:shadow-xl transition-all duration-500 bg-card rounded-3xl">
                <CardContent className="p-6 md:p-8 flex items-center gap-6">
                  <div className="bg-secondary text-primary p-5 rounded-2xl shrink-0 flex items-center justify-center">
                    <method.icon className="w-8 h-8 md:w-10 md:h-10" strokeWidth={1.5} />
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-lg md:text-xl font-semibold text-primary mb-1 font-sans">
                      {method.title}
                    </h3>
                    <p className="text-foreground text-xl md:text-2xl lg:text-3xl font-medium tracking-tight">
                      {method.value}
                    </p>
                  </div>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}